import apiFetch from '../apiFetch'

export default function (idPedido, token) {
  return apiFetch({endPoint: `Pedido/obtenerNumeroPedido`, method: 'GET', body: null, token: token})
}